import { render, staticRenderFns } from "./list-argolla.vue?vue&type=template&id=0902a66e"
import script from "./list-argolla.vue?vue&type=script&lang=js"
export * from "./list-argolla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports